import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Wizard, WizardStep, useStepController } from './Wizard/Wizard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useOffer } from '../../../context/offer/OfferContext';
import { ConnectionType } from '../../../services/FormsService/models/ConnectionType';
import { FormType } from '../../../services/FormsService/models/FormType';
import * as FormService from '../../../services/FormsService/forms.service';
import { FormRadioGrid, FormCheck } from 'floorplan/components/Form';
import { FormControl } from 'floorplan/components/v2/Form';
import { Button } from 'floorplan/components/v2/Button';
import { Rating, RatingView } from 'react-simple-star-rating';
import { RadioNps } from '../../UIComponents/RadioNps/RadioNps';
import TokenService from '../../../services/token.service';
import Checkbox from "../../UIComponents/Inputs/Checkbox";
import NumberedQuestionWizardStep from './NumberedQuestionWizardStep';
import cx from 'classnames';

import './SurveyContent.scss';

const ExitSurveyContent = (props) => {    
    const stepController = useStepController();    
    const [formSucceeded, updateFormSucceeded] = useState(false);
    const [formFailed, updateFormFailed] = useState(false);
    const [submitting, updateSubmitting] = useState(false);    

    const [form, updateForm] = useState({
        offerpadSatisfaction: 0,
        cashOfferDifficulty: 0,
        representativeCommunicationQuality: 0,
        isUnderstoodCashOfferListingOptions: false,
        freeLocalMoveServiceSatisfaction: 0,
        titleCompanySatisfaction: 0,        
        isSellReasonCashOfferConvenience: false,
        isSellReasonSellingTimelineControl: false,
        isSellReasonAvoidTradHomeShowings: false,
        isSellReasonFreeLocalMoveService: false,
        isSellReasonPriceLock: false,
        offerpadRecommendationLikelihood: 0,
        offerpadExperienceComments: '',
        offerpadImprovements: ''
    });

    const [formErrors, updateFormErrors] = useState({
        offerpadSatisfaction: false,
        cashOfferDifficulty: false,
        representativeCommunicationQuality: false,
        isUnderstoodCashOfferListingOptions: false,
        freeLocalMoveServiceSatisfaction: false,
        titleCompanySatisfaction: false,        
        isSellReasonCashOfferConvenience: false,
        isSellReasonSellingTimelineControl: false,
        isSellReasonAvoidTradHomeShowings: false,
        isSellReasonFreeLocalMoveService: false,
        isSellReasonPriceLock: false,
        offerpadRecommendationLikelihood: false,
        offerpadExperienceComments: false,
        offerpadImprovements: false
    });

    const updateField = (field, value) => {
        updateForm({ ...form, [field]: value });
        updateFormErrors({ ...formErrors, [field]: false });
    }

    const validate = (field) => {
        if (form[field] || form[field] === 0) {
            stepController.incrementStep();
        }
        else {
            if (form[field] || form[field] === 0) {
                stepController.incrementStep();
            }
            else {
                updateFormErrors({ ...formErrors, [field]: true });
            }
        }
    }

    const navigateAway = () => {
        const loggedIn = TokenService.getToken();
        if (loggedIn) {
            window.location.href = `${process.env.RAZZLE_CONNECT_URL}/sell/overview?transactionId=${props.acquisitionId}`
        } else {
            window.location.href = `https://www.offerpad.com/`;
        }
    };

    const submitForm = () => {
        if (submitting) {
            return;
        }
        updateSubmitting(true);
        FormService.submitForm({
            connectionId: props.acquisitionId,
            connectionType: ConnectionType.HelixEntity,
            formType: FormType.ClosedSurvey,
            items: Object.keys(form).map((key) => {
                return {
                    name: key,
                    value: form[key],
                };
            }),
        })
            .then(
                () => {
                    updateFormSucceeded(true);
                },
                () => {
                    updateFormFailed(true);
                })
            .catch(() => {
                updateFormFailed(true);
            })
            .finally(() => {
                updateSubmitting(false);
                stepController.incrementStep();
            });
    };

    const NavigationButtons = () => {
        return (
            <div className={cx({ 'btn-wrapper': true, 'd-none': submitting })} >
                {
                    (!formSucceeded && !formFailed && stepController.currentStep > 0) ?
                        <button
                            id="exit-survey-content-previous"
                            className="btn-survey-previous"
                            onClick={stepController.decrementStep}
                        >
                            <FontAwesomeIcon icon={['fas', 'long-arrow-left']} />
                            {' Back'}
                        </button>
                        :
                        <button id="exit-survey-content-close" className="btn-survey-previous" onClick={navigateAway}>
                            <FontAwesomeIcon icon={['fas', 'times']} />
                            {' Close'}
                        </button>
                }
            </div>
        )
    };

    return (
        <div>
            <NavigationButtons />
            <Wizard stepController={stepController} >                
                <WizardStep>
                    <div className="step-wrapper">
                        <div className="modal-main">
                            <div>
                                <img src={require('@assets/op-logo.svg')} className="logo" />
                            </div>
                            <div style={{ marginLeft: "8px" }}>
                                <h1 className="d-none d-md-block" style={{ margin: 0, padding: 0, marginTop: "8px", marginBottom: "8px" }} >Welcome</h1>
                                <div className="highlight">
                                    Thank you for choosing Offerpad! We value your feedback and look forward to hearing about your experience.
                                </div>
                            </div>
                            <div className="btn-wrapper pt-4">
                                <Button id="post-inspection-survey-begin" large onClick={stepController.incrementStep}>
                                    Let's Begin
                                </Button>
                            </div>
                        </div>
                    </div>
                </WizardStep>
                <NumberedQuestionWizardStep
                    question="How satisfied are you with your overall Offerpad experience?"
                    form={form}
                    field="offerpadSatisfaction"
                    error={formErrors}
                    errorText="Please select a number"
                    min={1}
                    max={5}
                    minLabel="Very dissatisfied"
                    maxLabel="Very satisfied"
                    onValidate={() => validate('offerpadSatisfaction')}
                    onUpdate={(option) => updateField('offerpadSatisfaction', option)}
                />
                <NumberedQuestionWizardStep
                    question="How easy was it to use our platform to receive an initial cash offer?"
                    form={form}
                    field="cashOfferDifficulty"
                    error={formErrors}
                    errorText="Please select a number"
                    min={1}
                    max={5}
                    minLabel="Very difficult"
                    maxLabel="Very easy"
                    onValidate={() => validate('cashOfferDifficulty')}
                    onUpdate={(option) => updateField('cashOfferDifficulty', option)}
                />
                <NumberedQuestionWizardStep
                    question="How would you rate the communication with your Offerpad representative?"
                    form={form}
                    field="representativeCommunicationQuality"
                    error={formErrors}
                    errorText="Please select a number"
                    min={1}
                    max={5}
                    minLabel="Poor"
                    maxLabel="Excellent"
                    onValidate={() => validate('representativeCommunicationQuality')}
                    onUpdate={(option) => updateField('representativeCommunicationQuality', option)}
                />
                <WizardStep>
                    <div className="step-wrapper">                        
                        <div className="modal-main">
                            <div>
                                <img src={require('@assets/op-logo.svg')} className="logo" />
                            </div>
                            <div className="highlight" style={{ margin: "8px" }}>
                                Did you clearly understand the solutions and benefits of the cash offer and listing options?
                            </div>
                            <div className="modal-body">
                                <FormControl
                                    id='transactionManagerKnowledgeable'
                                    className='simple-radios'
                                    name='transactionManagerKnowledgeable'
                                    value={form.isUnderstoodCashOfferListingOptions}
                                    hasError={formErrors.isUnderstoodCashOfferListingOptions}
                                    errorText={formErrors.isUnderstoodCashOfferListingOptions ? 'Please make a selection' : ''}
                                    onChange={() => updateField('isUnderstoodCashOfferListingOptions', !form.isUnderstoodCashOfferListingOptions)}
                                >
                                    <FormRadioGrid
                                        columns={1}
                                        bp='desktop'
                                    >
                                        <FormRadioGrid.Option
                                            id='transactionManagerKnowledgeable1'
                                            key='transactionManagerKnowledgeable1'
                                            label='Yes'
                                            value='Yes'
                                            checked={form.isUnderstoodCashOfferListingOptions === true}
                                        />                                        
                                        <FormRadioGrid.Option
                                            id='transactionManagerKnowledgeable4'
                                            key='transactionManagerKnowledgeable4'
                                            label='No'
                                            value='No'
                                            checked={form.isUnderstoodCashOfferListingOptions === false}
                                        />
                                    </FormRadioGrid>
                                </FormControl>
                                <div className="btn-wrapper pt-2">
                                    <Button
                                        id="post-inspection-0288"
                                        large                                        
                                        onClick={() => stepController.incrementStep()}
                                    >
                                        Continue
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </WizardStep>
                <NumberedQuestionWizardStep
                    question="How would you rate your experience with the Free Local Move service?"
                    form={form}
                    field="freeLocalMoveServiceSatisfaction"
                    error={formErrors}
                    errorText="Please select a number"
                    min={1}
                    max={5}
                    minLabel="Very dissatisfied"
                    maxLabel="Very satisfied"
                    onValidate={() => validate('freeLocalMoveServiceSatisfaction')}
                    onUpdate={(option) => updateField('freeLocalMoveServiceSatisfaction', option)}
                />
                <NumberedQuestionWizardStep
                    question="How would you rate your experience with the Title Company?"
                    form={form}
                    field="titleCompanySatisfaction"
                    error={formErrors}
                    errorText="Please select a number"
                    min={1}
                    max={5}
                    minLabel="Very dissatisfied"
                    maxLabel="Very satisfied"
                    onValidate={() => validate('titleCompanySatisfaction')}
                    onUpdate={(option) => updateField('titleCompanySatisfaction', option)}
                />
                <WizardStep>
                    <div className="step-wrapper">
                        <div className="modal-main">
                            <div>
                                <img src={require('@assets/op-logo.svg')} className="logo" />
                            </div>
                            <div className="highlight" style={{ margin: "8px" }}>
                                What were the reasons you chose Offerpad to sell your home? (Select all that apply)
                            </div>
                            <div className="modal-body">
                                <FormControl
                                    id='checklist-offerpad-sell-reasons'
                                    compact                                    
                                    isChecklist={true}
                                >
                                    <FormCheck
                                        id='gasCompanyNameCheckbox'
                                        name='gasCompanyNameCheckbox'
                                        checked={form.isSellReasonCashOfferConvenience}
                                        onChange={e => updateField('isSellReasonCashOfferConvenience', e.target.checked)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        The convenience of a cash offer
                                    </FormCheck>
                                    <FormCheck
                                        id='isSellReasonSellingTimelineControl'
                                        name='isSellReasonSellingTimelineControl'
                                        checked={form.isSellReasonSellingTimelineControl}
                                        onChange={e => updateField('isSellReasonSellingTimelineControl', e.target.checked)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        The ability to control the selling timeline
                                    </FormCheck>
                                    <FormCheck
                                        id='isSellReasonAvoidTradHomeShowings'
                                        name='isSellReasonAvoidTradHomeShowings'
                                        checked={form.isSellReasonAvoidTradHomeShowings}
                                        onChange={e => updateField('isSellReasonAvoidTradHomeShowings', e.target.checked)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        Avoiding traditional home showings
                                    </FormCheck>
                                    <FormCheck
                                        id='isSellReasonFreeLocalMoveService'
                                        name='isSellReasonFreeLocalMoveService'
                                        checked={form.isSellReasonFreeLocalMoveService}
                                        onChange={e => updateField('isSellReasonFreeLocalMoveService', e.target.checked)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        The Free Local Move service
                                    </FormCheck>
                                    <FormCheck
                                        id='isSellReasonPriceLock'
                                        name='isSellReasonPriceLock'
                                        checked={form.isSellReasonPriceLock}
                                        onChange={e => updateField('isSellReasonPriceLock', e.target.checked)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        PriceLock (certainty of your final selling price locked in at the time of contract signing)
                                    </FormCheck>
                                </FormControl>                                
                                <div className="btn-wrapper pt-2">
                                    <Button
                                        id="post-inspection-0288"
                                        large                                        
                                        onClick={() => stepController.incrementStep()}
                                    >
                                        Continue
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </WizardStep>                
                <NumberedQuestionWizardStep
                    question="How likely are you to recommend Offerpad to friends or family?"
                    form={form}
                    field="offerpadRecommendationLikelihood"
                    error={formErrors}
                    errorText="Please select a number"
                    min={1}
                    max={10}
                    minLabel="Very unlikely"
                    maxLabel="Very likely"
                    onValidate={() => validate('offerpadRecommendationLikelihood')}
                    onUpdate={(option) => updateField('offerpadRecommendationLikelihood', option)}
                />
                <NumberedQuestionWizardStep
                    question="How likely are you to personally use Offerpad again?"
                    form={form}
                    field="offerpadReuseLikelihood"
                    error={formErrors}
                    errorText="Please select a number"
                    min={1}
                    max={5}
                    minLabel="Very unlikely"
                    maxLabel="Very likely"
                    onValidate={() => validate('offerpadReuseLikelihood')}
                    onUpdate={(option) => updateField('offerpadReuseLikelihood', option)}
                />
                <WizardStep>
                    <div className="step-wrapper">
                        <div className="modal-main">
                            <div>
                                <img src={require('@assets/op-logo.svg')} className="logo" />
                            </div>
                            <div className="highlight" style={{ margin: "8px" }}>
                                What was the best part of your Offerpad experience?  Any representative you'd like to shout out?
                            </div>
                            <div style={{ margin: "8px" }}>
                                <FormControl
                                    id='offerpadComments'
                                    name='offerpadComments'
                                    placeholder="Tell us more"
                                    value={form.offerpadExperienceComments}
                                    onChange={(e) =>
                                        updateForm({
                                            ...form, offerpadExperienceComments: e.target.value
                                        })}
                                >
                                    <textarea
                                        name="offerpadComments"
                                        rows={4}
                                    ></textarea>
                                </FormControl>
                                <div className="btn-wrapper pt-2">
                                    <Button
                                        id="post-inspection-0288"
                                        large                                        
                                        onClick={() => stepController.incrementStep()}
                                    >
                                        Continue
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </WizardStep>
                <WizardStep>
                    <div className="step-wrapper">
                        <div className="modal-main">
                            <div>
                                <img src={require('@assets/op-logo.svg')} className="logo" />
                            </div>
                            <div className="highlight" style={{ margin: "8px" }}>
                                What could we have done to improve your experience?
                            </div>
                            <div style={{ margin: "8px" }}>
                                <FormControl
                                    id='offerpadComments'
                                    name='offerpadComments'
                                    placeholder="Tell us more"
                                    value={form.offerpadImprovements}
                                    onChange={(e) =>
                                        updateForm({
                                            ...form, offerpadImprovements: e.target.value
                                        })}
                                >
                                    <textarea
                                        name="offerpadComments"
                                        rows={4}
                                    ></textarea>
                                </FormControl>
                                <div className="btn-wrapper pt-5 new-pull-right">
                                    <Button
                                        id="post-inspection-submit-form"
                                        large
                                        disabled={submitting}
                                        onClick={submitForm}
                                    >
                                        {(submitting ? 'Submitting...' : 'Submit survey')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </WizardStep>
                <WizardStep>
                    <div className="p-2">
                        <div className="survey-end">
                            {
                                formSucceeded && <h3>Thank you for sharing your feedback!</h3>                                    
                            }
                            {
                                formFailed &&
                                <h3>
                                    We encountered an issue while submitting your survey. Please try again later.
                                </h3>
                            }
                            <div className="d-flex justify-content-center">
                                <img src={require('@assets/illustrations/survey_finished_icon.svg')} />
                            </div>
                            <div>
                                <label>If you'd like, you can also leave a review here: <a href="https://www.trustpilot.com/evaluate/www.offerpad.com">Trustpilot</a></label>
                            </div>
                        </div>
                    </div>
                </WizardStep>
            </Wizard>
        </div>
    );
}

export default ExitSurveyContent;
